import React from 'react';
import useMedia from 'use-media';
import logo from "../../resources_catalog/logo_rtcc.svg";
import pdf_img from "../../resources_catalog/icons/ico_pdf.svg";
import travelConditionsJpPdf from "../../resources_catalog/pdf/国内海外手配旅行 旅行条件書（RTCC宿泊プラン）.pdf"
import travelConditionsOverseasPdf from "../../resources_catalog/pdf/海外募集型企画旅行 旅行条件書（RTCC 海外宿泊プラン）.pdf"
import standardAgreementPdf from "../../resources_catalog/pdf/標準旅行業約款.pdf"
export const CatalogFooterContainer = () => {

  const isWideTablet = useMedia({ maxWidth: '960px' });
  const isWidePhone = useMedia({ maxWidth: '480px' });

  // スクロールトップボタン
  const scrollTop = () => {
    window.scroll({ top: 0, behavior: 'smooth' })
  }

  return (
    <div className="catalogFooterWrap">
      <button className="scrollButton" onClick={scrollTop}></button>
      <div className="catalogFooter">
        <div className="catalogFooterTop">
          <div className="catalogFooterTopInner">
            <div className="catalogFooterTopInnerTitle">お問い合わせ</div>
            <div className="catalogFooterTopInnerBox">
              <div className="catalogFooterTopInnerBlock">
                <p className="catalogFooterTopInnerBlockTitle">RTCC事務局</p>
                <p className="catalogFooterTopInnerBlockNum">052-307-3030</p>
              </div>
              <div className="catalogFooterTopInnerBlock">
                <p className="catalogFooterTopInnerBlockTime">受付時間：平日10:00～17:00</p>
                <p className="catalogFooterTopInnerBlockTime">休業日：土日祝と当社が定める休業日</p>
              </div>
            </div>
          </div>
        </div>
        <div className="catalogFooterMiddle">
          <div className="catalogFooterMiddleInner">
            <div className="catalogFooterMiddleInnerTop">
              <div className="catalogFooterMiddleInnerPdfWrap">
                <div className="catalogFooterMiddleInnerPdf">
                  <img src={pdf_img} alt="" />
                  <p><a href={standardAgreementPdf} target="_blank" rel="noopener noreferrer">標準旅行業約款</a></p>
                </div>
                <div className="catalogFooterMiddleInnerPdf">
                  <img src={pdf_img} alt="" />
                  <p><a href={travelConditionsOverseasPdf} target="_blank" rel="noopener noreferrer">RTCCハワイ<br />海外募集型企画旅行 旅行条件書</a></p>
                </div>
                <div className="catalogFooterMiddleInnerPdf">
                  <img src={pdf_img} alt="" />
                  <p><a href={travelConditionsJpPdf} target="_blank" rel="noopener noreferrer">RTCC宿泊<br/>国内・海外手配旅行 旅行条件書</a></p>
                </div>
              </div>
            </div>
            <div className="catalogFooterMiddleInnerBottom">
              <div className="catalogFooterMiddleInnerBottomInner">
                <ul className="catalogFooterMiddleInnerBottomListWrap">
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/privacy_toriatsukai/" target="_blank" rel="noopener">個人情報等の取扱いについて</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/environment_policy/" target="_blank" rel="noopener">環境方針</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/quality/" target="_blank" rel="noopener">品質管理方針</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/anti_social_policy/" target="_blank" rel="noopener">反社会的勢力に対する基本方針</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/security_policy/" target="_blank" rel="noopener">情報セキュリティ方針</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/social_media_policy/" target="_blank" rel="noopener">ソーシャルメディアポリシー</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/privacy_policy/" target="_blank" rel="noopener">プライバシーポリシー</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/specific_privacy/" target="_blank" rel="noopener">特定個人情報等の適正な取扱いに関する基本方針</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/disclosure_policy/" target="_blank" rel="noopener">ディスクロージャーポリシー</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/health/" target="_blank" rel="noopener">健康経営宣言</a></li>
                  <li className="catalogFooterMiddleInnerBottomList"><a href="https://www.resorttrust.co.jp/corporate/terms/" target="_blank" rel="noopener">サイトの利用条件</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="catalogFooterBottom">
          <div className="catalogFooterBottomInner">
            <img src={logo} alt="" className="catalogFooterBottomInnerImg" />
            <p className="catalogFooterBottomInnerText">COPYRIGHT © RESORTTRUST ALL RIGHTS RESERVED.</p>
          </div>
        </div>
      </div>
    </div>
  )
};
